import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cachedPromise = null;

export function useAirlineLogos() {
  const [logos, setLogos] = useState({});

  useEffect(() => {
    if (!cachedPromise) {
      cachedPromise = api.get("/site/airline-logos").then((r) => r.data || {}).catch(() => ({}));
    }
    cachedPromise.then(setLogos);
  }, []);

  return logos;
}

export function airlineLogoUrl(logosMap, code) {
  const entry = logosMap?.[(code || "").toUpperCase()];
  const u = entry?.logo_url;
  if (!u) return "";
  return u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;
}
